// 星牛 /ops 运营端路由（Colastar G-UI-6 起；G-UI-7 v7 黑加底部四格 tab 与 /ops/runs）：独立布局与守卫，与 AICON 侧栏 / MainLayout 零关联。
// 由 router/index.js 在 G-UI-3 追加块之后以两行并入（import + routes.push），本文件之外恒不改上游路由。
// 守卫只在本组路由上（beforeEnter），恒不写 meta.requiresAuth：全局守卫会把未登录者送到 AICON 登录页，/ops 要去 /ops/login。
// 同理恒不写 meta.requiresGuest（全局守卫会把已登录者送去 AICON 的 /dashboard）；已登录进 /ops/login 由本组守卫送回 /ops。
// 守卫逐条挂在子路由上：父路由的 beforeEnter 只在从外面进 /ops 时跑一次，子路由之间切换不会再跑。
// meta.tab = 底部 tab 哪一格亮（home / create / output / me）；meta.tabbar === false = 这页不显示 tab（创作页的底栏给「本次约 N 分 + 生成」）。
import { useAuthStore } from '@/stores/auth'

const OpsLayout = () => import('@/components/ops/OpsLayout.vue')
const OpsLogin = () => import('@/views/ops/OpsLogin.vue')
const OpsHome = () => import('@/views/ops/OpsHome.vue')
const OpsTemplates = () => import('@/views/ops/OpsTemplates.vue')
const OpsCreate = () => import('@/views/ops/OpsCreate.vue')
const OpsOutput = () => import('@/views/ops/OpsOutput.vue')
const OpsRunsLatest = () => import('@/views/ops/OpsRunsLatest.vue')
const OpsMine = () => import('@/views/ops/OpsMine.vue')

// 没登录 → /ops/login?redirect=<要去的地方>
export function requireOpsLogin(to) {
  if (!useAuthStore().isAuthenticated) {
    return { path: '/ops/login', query: { redirect: to.fullPath } }
  }
  return true
}

// 已登录还进登录页 → 直接去 /ops
export function opsGuestOnly() {
  return useAuthStore().isAuthenticated ? { path: '/ops' } : true
}

export default [
  {
    path: '/ops',
    component: OpsLayout,
    children: [
      { path: 'login', name: 'OpsLogin', component: OpsLogin, beforeEnter: opsGuestOnly, meta: { title: '星牛 · 登录' } },
      { path: '', name: 'OpsHome', component: OpsHome, beforeEnter: requireOpsLogin, meta: { title: '星牛', tab: 'home' } },
      // 三页极简令 v1（Owner 认稿 ①）：「模板生成」另开选模板页
      { path: 'templates', name: 'OpsTemplates', component: OpsTemplates, beforeEnter: requireOpsLogin, meta: { title: '星牛 · 选模板', tab: 'home' } },
      {
        path: 'create',
        name: 'OpsCreateFree',
        component: OpsCreate,
        beforeEnter: requireOpsLogin,
        meta: { title: '星牛 · 创作', tab: 'create', tabbar: false }
      },
      {
        path: 'create/:templateId',
        name: 'OpsCreate',
        component: OpsCreate,
        beforeEnter: requireOpsLogin,
        meta: { title: '星牛 · 创作', tab: 'create', tabbar: false }
      },
      // 底部「出片」格：最近一条有就换到它的出片页，没有说「还没出过片」
      { path: 'runs', name: 'OpsRunsLatest', component: OpsRunsLatest, beforeEnter: requireOpsLogin, meta: { title: '星牛 · 出片', tab: 'output' } },
      { path: 'runs/:id', name: 'OpsOutput', component: OpsOutput, beforeEnter: requireOpsLogin, meta: { title: '星牛 · 出片', tab: 'output' } },
      { path: 'me', name: 'OpsMine', component: OpsMine, beforeEnter: requireOpsLogin, meta: { title: '星牛 · 我的', tab: 'me' } },
      // 未匹配的 /ops/... 回 /ops（没登录再由 /ops 的守卫送去登录页）；用 + 不用 *，免得和 /ops 本身抢匹配
      { path: ':rest(.*)+', redirect: '/ops' }
    ]
  }
]
